var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60.5 65",
    style: {
      enableBackground: "new 0 0 60.5 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EEBF49;}\n\t.st1{fill:#E13332;}\n\t.st2{fill:#4C4646;}\n\t.st3{fill:#4A72DD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_323",
    transform: "translate(-32.553 -96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_119",
    x: 80.1,
    y: 109.4,
    className: "st0",
    width: 12,
    height: 34.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_115",
    className: "st1",
    d: "M88.2,98.4H84c-2.2,0-3.9,1.8-3.9,3.9v2.3c0,0.8,0.6,1.5,1.4,1.6c0,0,0.1,0,0.1,0h8.9 c0.8,0,1.5-0.6,1.6-1.4c0,0,0-0.1,0-0.1v-2.3C92,100.2,90.3,98.5,88.2,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_116",
    className: "st2",
    d: "M90.5,147.2h-8.9c-0.8,0-1.5,0.7-1.5,1.5c0,0.3,0.1,0.6,0.2,0.8l4.4,7c0.4,0.7,1.3,1,2,0.6 c0.3-0.1,0.5-0.4,0.6-0.6l4.4-7c0.4-0.7,0.2-1.7-0.5-2.1C91.1,147.3,90.8,147.2,90.5,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_117",
    className: "st3",
    d: "M74.2,97.1H37.4c-2.2,0.1-3.9,1.9-4,4v54.7c0.1,2.2,1.9,3.9,4,4h36.8c2.2-0.1,3.9-1.9,4-4 v-54.7C78.1,99,76.4,97.2,74.2,97.1z M39.1,103.1h18.8c0.5,0,1,0.4,1,1s-0.4,1-1,1H39.1c-0.5,0-1-0.4-1-1S38.6,103.1,39.1,103.1z  M72.4,153.8H39.1c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9C73.5,153.3,73,153.8,72.4,153.8 C72.5,153.8,72.5,153.8,72.4,153.8z M72.4,148.5H39.1c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9 C73.5,148,73,148.4,72.4,148.5C72.5,148.5,72.5,148.5,72.4,148.5z M72.4,143.1H39.1c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1 c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9C73.5,142.7,73,143.1,72.4,143.1C72.5,143.1,72.5,143.1,72.4,143.1z M72.4,137.4H39.1 c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9C73.5,136.9,73,137.4,72.4,137.4 C72.5,137.4,72.5,137.4,72.4,137.4z M72.4,132.1H39.1c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9 C73.5,131.6,73,132,72.4,132.1C72.5,132.1,72.5,132.1,72.4,132.1z M72.4,126.7H39.1c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1 c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9C73.5,126.3,73,126.7,72.4,126.7C72.5,126.7,72.5,126.7,72.4,126.7z M72.4,121.2H39.1 c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9C73.5,120.7,73,121.2,72.4,121.2 C72.5,121.2,72.5,121.2,72.4,121.2z M72.4,115.7H39.1c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9 C73.5,115.2,73,115.6,72.4,115.7C72.5,115.7,72.5,115.7,72.4,115.7z M72.4,110.3H39.1c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1 c0,0,0,0,0.1,0h33.3c0.5,0,1,0.4,1,0.9C73.5,109.9,73,110.3,72.4,110.3C72.5,110.3,72.5,110.3,72.4,110.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaes);
export default __webpack_public_path__ + "static/media/icon-paes.4775be1c3edc32dddaf1f4a305c4281c.svg";
export { ForwardRef as ReactComponent };